// extracted by mini-css-extract-plugin
export default {"root":"AvatarEmotionSelect_root__sl1Y7","itemWrapper":"AvatarEmotionSelect_itemWrapper__2p9ce","item":"AvatarEmotionSelect_item__PDTku","input":"AvatarEmotionSelect_input__TjkiS"};